import React, { Component } from "react";
import Cleave from "cleave.js/react";
import { connect } from "react-redux";
import {
  Container, Form, FormGroup, Input, Button, Row, Col, UncontrolledAlert,
  Modal, ModalHeader, ModalBody, ModalFooter, Card, CardHeader, CardBody
} from "reactstrap";
import { getSignupInfo } from "../../actions/modules_action/customizations";
import "./style.css";
import background from "./../../images/background.jpg";
import { getGeneral } from '../../actions/modules_action/customizations';
import { API_URL } from './../../constants';
import EduSpinner from "../common/EduSpinner";

class SignupContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        termsNConditions: false
      },
      signupInfo: {
        eventInfo: "",
        box1Title: "",
        box2Title: "",
        box1Desc: "",
        box2Desc: ""
      },
      isConditionReading: false,
      accessId: 1,
      loadingSignupInfo: true,
      loadingGeneral: true,
      logo_image: '',
    };
  }

  componentDidMount() {
    this.props.getSignupInfo(this.props.token, this.state.accessId);
    this.props.getGeneral(this.props.token, this.state.accessId);
  }

  componentDidUpdate(prevProps) {
    // SignupInfo loading logic
    if (
      this.props.GetSignupInfo !== prevProps.GetSignupInfo &&
      this.props.GetSignupInfo &&
      "status" in this.props.GetSignupInfo
    ) {
      if (
        this.props.GetSignupInfo.status &&
        this.props.GetSignupInfo.data &&
        Object.keys(this.props.GetSignupInfo.data).length > 0
      ) {
        this.setState({
          signupInfo: {
            ...this.state.signupInfo,
            eventInfo: this.props.GetSignupInfo.data.eventInfo,
            box1Title: this.props.GetSignupInfo.data.box1Title,
            box2Title: this.props.GetSignupInfo.data.box2Title,
            box1Desc: this.props.GetSignupInfo.data.box1Desc,
            box2Desc: this.props.GetSignupInfo.data.box2Desc
          },
          loadingSignupInfo: false
        });
      } else {
        this.setState({ loadingSignupInfo: false });
      }
    }

    // General loading logic
    if (
      this.props.GetGeneral !== prevProps.GetGeneral &&
      this.props.GetGeneral &&
      "status" in this.props.GetGeneral
    ) {
      if (
        this.props.GetGeneral.status &&
        this.props.GetGeneral.data &&
        Object.keys(this.props.GetGeneral.data).length > 0
      ) {
        this.setState({
          logo_image: this.props.GetGeneral.data.logo_image,
          loadingGeneral: false
        });
      } else {
        this.setState({ loadingGeneral: false });
      }
    }
  }

  handleChange = event => {
    let attribute = event.target.getAttribute("data-state");
    let value = event.target.value;

    if (attribute === "termsNConditions") {
      value = event.target.checked; // Use checked property for checkbox
    }

    this.setState({
      form: {
        ...this.state.form,
        [attribute]: value
      }
    });
  };

  handleMessage = () => {
    if (this.props.error !== "") {
      return (
        <Col>
          <UncontrolledAlert className="text-left" color="danger">
            <strong>Error:</strong> {this.props.error}
          </UncontrolledAlert>
        </Col>
      );
    } else if (this.props.success !== "") {
      return (
        <Col>
          <UncontrolledAlert className="text-left" color="success ">
            <strong>Success:</strong> {this.props.success}
          </UncontrolledAlert>
        </Col>
      );
    }
  };

  conditionReadingToggle = event => {
    if (event) event.preventDefault();
    this.setState({ isConditionReading: !this.state.isConditionReading });
  };

  termsNConditions = () => (
    <Modal
      isOpen={this.state.isConditionReading}
      toggle={this.conditionReadingToggle}
      className={this.props.className}
    >
      <ModalHeader toggle={this.conditionReadingToggle}>
        <span className="display-5">Terms & Conditions</span>
      </ModalHeader>
      <ModalBody>
        <p className="text-left text-medium">
          Please read these Terms and Conditions...
        </p>
        <strong>
          By accessing or using the Service you agree to be bound by these Terms...
        </strong>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary btn-auto" onClick={this.conditionReadingToggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );

  handleSubmit = event => {
    event.preventDefault();
    this.props.submit(this.state.form);
  };

  render = () => {
    const isLoading = this.state.loadingSignupInfo || this.state.loadingGeneral;

    if (isLoading) {
      return (
        <div id="signup-page" style={{ backgroundImage: `url(${background})` }}>
          <Container>
            <EduSpinner label="Loading sign up information..." />
          </Container>
        </div>
      );
    }

    return (
      <div id="signup-page" style={{ backgroundImage: `url(${background})` }}>
        <Container fluid={true}>
          <Row>
            {this.props.event && (
              <Col sm="3" className="signupdayinfo">
                <Card>
                  <CardHeader className="schedulecardhead">
                    {this.state.signupInfo.box1Title}
                  </CardHeader>
                  <CardBody className="schedulecardbody">
                    <div dangerouslySetInnerHTML={{ __html: this.state.signupInfo.box1Desc }} />
                  </CardBody>
                </Card>
              </Col>
            )}
            <Col sm={{ size: 6, offset: this.props.event ? 0 : 3 }}>
              <div className="form-heading text-center mt-5 mb-4">
                <a href="/#/">
                  <img src={`${API_URL}/${this.state.logo_image}`} alt="Logo" style={{ width: '600px' }} />
                </a>
              </div>
              <div className="signup-form text-center">
                <Col>
                  <h1 className="display-4">Sign Up</h1>
                  {this.props.event && (
                    <div dangerouslySetInnerHTML={{ __html: this.state.signupInfo.eventInfo }} />
                  )}
                </Col>
                {this.handleMessage()}
                <Col>
                  <Form id="signup" onSubmit={this.handleSubmit}>
                    <Row>
                      <Col xs="12" sm="6">
                        <FormGroup>
                          <Input
                            type="text"
                            name="first-name"
                            data-state="firstName"
                            className="form-control"
                            placeholder="First Name"
                            value={this.state.form.firstName}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" sm="6">
                        <FormGroup>
                          <Input
                            type="text"
                            name="last-name"
                            data-state="lastName"
                            className="form-control"
                            placeholder="Last Name"
                            value={this.state.form.lastName}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" sm="6">
                        <FormGroup>
                          <Input
                            type="email"
                            name="email"
                            data-state="email"
                            className="form-control"
                            placeholder="Email Address"
                            value={this.state.form.email}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" sm="6">
                        <FormGroup>
                          <Cleave
                            name="phone"
                            data-state="phone"
                            className="form-control"
                            placeholder="Phone Number"
                            value={this.state.form.phone}
                            options={{
                              delimiter: "-",
                              blocks: [3, 3, 4]
                            }}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" sm="6">
                        <FormGroup>
                          <Input
                            type="password"
                            name="password"
                            data-state="password"
                            className="form-control"
                            placeholder="Password"
                            value={this.state.form.password}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" sm="6">
                        <FormGroup>
                          <Input
                            type="password"
                            name="confirm-password"
                            data-state="confirmPassword"
                            className="form-control"
                            placeholder="Confirm Password"
                            value={this.state.form.confirmPassword}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="mb-4 text-left">
                      <Col>
                        <div className="form-check">
                          <label className="ml-2">
                            <Input
                              type="checkbox"
                              name="terms-n-conditions"
                              data-state="termsNConditions"
                              checked={this.state.form.termsNConditions}
                              onChange={this.handleChange}
                            />
                            <span>
                              I Read and Accept the{" "}
                              <a
                                onClick={this.conditionReadingToggle}
                                className="pointer"
                              >
                                Terms & Conditions
                              </a>
                            </span>
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <Button
                      color="info"
                      disabled={!this.state.form.termsNConditions}
                    >
                      Sign Up
                    </Button>
                  </Form>
                  <div className="card-footer mt-3 text-medium">
                    Already have an account?&nbsp;
                    <a href="/#/login">Login</a>
                  </div>
                </Col>
              </div>
              {this.termsNConditions()}
            </Col>
            {this.props.event && (
              <Col sm="3" className="signupdayinfo">
                <Card>
                  <CardHeader className="schedulecardhead">
                    {this.state.signupInfo.box2Title}
                  </CardHeader>
                  <CardBody className="schedulecardbody">
                    <div dangerouslySetInnerHTML={{ __html: this.state.signupInfo.box2Desc }} />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  };
}

const mapStateToProps = state => ({
  GetSignupInfo: state.GetSignupInfo,
  GetGeneral: state.GetGeneral
});

export default connect(
  mapStateToProps,
  { getSignupInfo, getGeneral }
)(SignupContainer);